<div class="col-sm-12 coldx">
    <div class="col-sm-12 coldx">
      <h4>Timbratura</h4>
    </div>
</div>
<app-mark-document-form [document]="document" [idFascicolo]="idFascicolo" (onSubmit)="onSubmit($event)"></app-mark-document-form>
